module.exports = "/images/vendor/desiigner-svg/svg/logos/italia-on-the-road.svg?13bfb19cb5e1494b6f285124d0bc2799";